(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name transactions.controller:TransactionsCtrl
   *
   * @description
   *
   */
  angular
    .module('transactions')
    .controller('TransactionsCtrl', TransactionsCtrl);

  function TransactionsCtrl() {
    var vm = this;
    vm.ctrlName = 'TransactionsCtrl';
  }
}());
